import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import moment from 'moment';

import DetailFieldText from 'fixedassets/components/detail/field/DetailFieldText';

const DetailFieldDateTime = ({ label, value, t }) => {
  value = moment(value);
  return (
    <DetailFieldText
      label={label}
      value={value.isValid() ? value.format('DD/MM/YYYY HH:MM:SS') : null}
    />
  );
};

DetailFieldDateTime.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  t: PropTypes.func.isRequired,
};

export default translate()(DetailFieldDateTime);



// WEBPACK FOOTER //
// src/modules/secured/modules/fixedassets/components/detail/field/DetailFieldDateTime.js